import React, {Fragment} from 'react';
import {Calendar} from 'primereact/calendar';
import locale from '../../config/locale';
import moment from 'moment';
import classNames from "classnames";
import PropTypes from 'prop-types';
import Button from "./Button";
import DatePicker from "react-datepicker";
import {stringToDate} from "../../utils/other";

export const getFormat = (format, showTime, timeOnly) => {
    return format || (timeOnly ? "HH:mm:00" : ("YYYY-MM-DD" + (showTime ? " HH:mm:00" : "")));
}

export const dateData = (value, showTime, timeOnly, format) => {

    format = getFormat(format, showTime, timeOnly);

    let m = moment(value, format);
    if(m.isValid()) {
        return {
            value: m.format(format),
            dateValue: m.toDate(),
            momentValue: m,
            format: format
        }
    } else {
        return {
            value: null,
            dateValue: null,
            momentValue: m,
            format: format
        }
    }
}

const year = new Date().getFullYear();

class DateTimeInput extends React.Component {

    static defaultProps = {
        actionsOn: "all"
    }

    static propTypes = {
        showTime: PropTypes.bool,
        timeOnly: PropTypes.bool,
        required: PropTypes.bool,
        value: PropTypes.any,
        saveChanges: PropTypes.func,
        name: PropTypes.string,
        label: PropTypes.any,
        placeholder: PropTypes.string,
        format: PropTypes.string,
        isClearable: PropTypes.bool,
        error: PropTypes.any,
        minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
        maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
        disabled: PropTypes.oneOf([true, false, "true", "false", "disabled"]),
        asMoment: PropTypes.oneOf([true, false]),
        //selectionMode: PropTypes.oneOf(["single", "range"]),
        actionsOn: PropTypes.oneOf(["all", "start", "end"]),
        yearRange: PropTypes.string,
        initialValue: PropTypes.any
    }

    onSelect = (newValue, event) => {
        let value = newValue || this.props.value || this.props.initialValue;
        if (((this.props.selectionMode || "single") !== "single" && event === "change") || (this.props.selectionMode || "single") === "single") {
            if(this.props.saveChanges && newValue !== undefined) {
                let value = newValue || this.props.value || this.props.initialValue;
                if (
                    (this.props.selectionMode || "single") !== "single"
                    && Array.isArray(value)
                    &&
                    (
                        this.props.actionsOn === "all" ||
                        (this.props.actionsOn === "start" && value.length === 1) ||
                        (this.props.actionsOn === "end" && value.length === 2)
                    )
                ) {
                    value = value.map((_value) => {
                        const stateValue = this.dateData(_value);
                        if (!this.props.asMoment) {
                            _value = stateValue.value;
                        } else {
                            _value = stateValue.momentValue;
                            if (_value) {
                                _value.toFormat = function () {
                                    return _value.format(stateValue.format);
                                };
                                _value.toFormat.bind(_value);
                            }
                        }
                        return _value;
                    });
                } else {
                    let stateValue = this.dateData(value);
                    if (!this.props.value && this.props.initialValue) {
                        stateValue = this.dateData(stateValue.momentValue.format("YYYY-MM-DD ") + this.dateData(this.props.initialValue).momentValue.format("HH:mm:00"));
                    }
                    if (!this.props.asMoment) {
                        value = stateValue.value;
                    } else {
                        value = stateValue.momentValue;
                        if (value) {
                            value.toFormat = function () {
                                return value.format(stateValue.format);
                            };
                            value.toFormat.bind(value);
                        }
                    }
                }
                this.props.saveChanges(this.props.name, value);
            }
        }
    }

    dateData = (value) => {

        let format = this.getFormat();

        let m = moment(value, format);
        if(m.isValid()) {
            return {
                value: m.format(format),
                dateValue: m.toDate(),
                momentValue: m,
                format: format
            }
        } else {
            return {
                value: null,
                dateValue: null,
                momentValue: m,
                format: format
            }
        }
    }

    getFormat = () => {
        return getFormat(this.props.format, this.props.showTime, this.props.timeOnly);
    }

    render() {
        const style = {};
        if (this.props.label === false) {
            style.display = "none";
        }
        const stateValue = (this.props.selectionMode || "single") !== "single" && Array.isArray(this.props.value) ? (this.props.value).map((value) => this.dateData(value).dateValue) : this.dateData(this.props.value).dateValue;
        const isClearAble = this.props.isClearable && stateValue;
        let minDate = this.props.minDate;
        minDate = typeof minDate === 'string' ? this.dateData(minDate).dateValue : minDate;
        let maxDate = this.props.maxDate;
        maxDate = typeof maxDate === 'string' ? this.dateData(maxDate).dateValue : maxDate;
        const yearRange = this.props.yearRange || ((year - 5) + ":" + (year + 5));
        const format = (this.props.timeOnly ? " HH:mm" : (this.props.showTime ? locale.dateFormat + " HH:mm" : locale.dateFormat));
        return <Fragment>
            <label htmlFor={ this.props.name } className="control-label" style={style}>{this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}</label>
            <div className={classNames({"input-group": isClearAble})}>
                <DatePicker
                    name={this.props.name}
                    autoComplete="off"
                    placeholderText={this.props.placeholder}
                    selected={stateValue}
                    onSelect={(value) => this.onSelect(value, "change")}
                    onChange={(value) => this.onSelect(value, "change")}
                    onChangeRaw={(event) => {
                        let value = event.target.value;
                        if (value) {
                            value = stringToDate(value.toLowerCase().trim());
                            if (value) {
                                this.onSelect(value, "change");
                            }
                        }
                    }}
                    timeFormat="HH:mm"
                    dateFormat={format}
                    showPopperArrow={false}
                    /*selectsStart={this.props.selectsStart}
                    selectsEnd={this.props.selectsEnd}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}*/
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    renderDayContents={(day, date) => {
                        return <span>{day}</span>;
                    }}
                    dayClassName={(date) => {
                        if (moment(date).isBetween(this.props.startDate, this.props.endDate)) {
                            return "react-datepicker__day--in-range";
                        }
                    }}
                    className={classNames({"is-invalid": this.props.error})}
                    disabled={this.props.disabled === "true" || this.props.disabled === "disabled" || this.props.disabled}
                    minDate={minDate}
                    maxDate={maxDate}
                    showTimeInput={this.props.timeOnly ? true : this.props.showTime}
                    showTimeSelectOnly={this.props.timeOnly}
                    openToDate={stateValue ? stateValue : (this.props.initialValue ? this.dateData(this.props.initialValue).dateValue : null)}
                />
                {isClearAble && <span className="input-group-btn">
                    <Button icon={{lib: "fa", name: "times"}} color="default" onClick={() => this.props.saveChanges(this.props.name, null)} disabled={ this.props.disabled === "true" || this.props.disabled === "disabled" || this.props.disabled } />
                </span>}
            </div>
            {this.props.error && <div className="invalid-feedback">{this.props.error}</div>}
        </Fragment>;
    }
}

export default DateTimeInput;